



































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import Modifiable from '@/mixins/Modifiable'

@Component({ name: 'v-button' })
export default class VButton extends Mixins(Modifiable) {
    /**
     * Button style type
     */
    @Prop({ type: String, default: 'primary' })
    type!: 'primary-ghost'
        | 'primary'
        | 'error-ghost'
        | 'grey-ghost'
        | 'primary-inverted'
        | 'grey-dark'
        | 'primary-dull'
        | 'danger-dull'
        | 'grey-dull'

    /**
     * Button size
     *
     * @var {String}
     */
    @Prop({ type: String, default: 'md' })
    size!: 'xs' | 'sm' | 'md' | 'lg' | 'xl'

    /**
     * Whether to use an outline variant
     */
    @Prop({ type: Boolean, default: false })
    outline!: boolean

    /**
     * Whether button should be full width
     */
    @Prop({ type: Boolean, default: false })
    fullWidth!: boolean

    /**
     * Whether the icon should float instead of sit inline
     */
    @Prop({ type: Boolean, default: false })
    floatIcon!: boolean

    /**
     * Icon to show on the left
     */
    @Prop({ type: String, default: null })
    iconLeft!: string

    /**
     * Icon to show on the right
     */
    @Prop({ type: String, default: null })
    iconRight!: string

    /**
     * Whether to add extra margin between the text and the icon
     */
    @Prop({ type: Boolean, default: true })
    pushIcon!: boolean

    /**
     * Whether the button is a submit button
     */
    @Prop({ type: Boolean, default: false })
    submit!: boolean

    /**
     * Whether the button is disabled
     */
    @Prop({ type: Boolean, default: false })
    disabled!: boolean

    /**
     * Which theme to invert colours on
     */
    @Prop({ type: String })
    invert!: 'light' | 'dark'
}
